// Services.js
import React from "react";
import "../Styles/services.css";
import { Link } from "react-router-dom";


const Services = () => {
  return (
    <div className="services-page">
      <h2 className="services-heading">Our Services</h2>

      <div className="service-grid">
      <div className="service-grid">
  <Link to="/services/topup" className="service-card">
    <h3>📲 Mobile Top-Up</h3>
    <p>Top-up for Digicel, GTT, and Enet — both retail and wholesale.</p>
  </Link>

  <Link to="/services/mmg" className="service-card">
    <h3>💸 MMG+ Transactions</h3>
    <p>We are the only MMG+ Superagent on Wakenaam.</p>
  </Link>

  <Link to="/services/bills" className="service-card">
    <h3>📄 Bill Payments</h3>
    <p>Pay your ALL your bills under one roof!</p>
  </Link>

  <Link to="/services/ferry" className="service-card">
    <h3>⛴️ Ferry Pass Booking</h3>
    <p>Book vehicle and passenger passes for the Guyana Ferry Services, ANYWHERE IN GUYANA!.</p>
  </Link>

  <Link to="/services/business" className="service-card">
    <h3>💰Moneygram and WIDIT Bill Payment Services</h3>
    <p>For all international and Local Money transfers!</p>
  </Link>

  <Link to="/services/insurance" className="service-card">
    <h3>🗃️Insurance Brokerage</h3>
    <p>Insurance services, for New policies and renewals.</p>
  </Link>
  
  <Link to="/services/investors" className="service-card">
  <h3>📈 Investors</h3>
  <p>RCS houses a number of investment services, click here to find out more!.</p>
</Link>

<Link to="/services/others" className="service-card">
  <h3>🛠️ Other Services</h3>
  <p>Explore additional services offered by RCS.</p>
</Link>

</div>

      </div>
    </div>
  );
};

export default Services;
